/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotInMapping = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m4.336 14.42-.294-4.452V7h1.89v2.968l-.294 4.452H4.336zM4 17.178v-1.75h1.974v1.75H4zm4.222 0V7h1.75v10.178h-1.75zm3.882 0V7h1.639l4.885 7.308V7h1.736v10.178h-1.637L13.84 9.884v7.294h-1.736z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNotInMapping as NotInMapping };
